export default "__VITE_ASSET__DyCOLiiC__"